import { useEffect, useRef } from "react";
interface PropsVideoPlayer {
  link: string;
}

export default function VideoPlayer({ link }: PropsVideoPlayer) {
  const videoRef = useRef<HTMLVideoElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          void videoRef.current?.play();
        } else {
          videoRef.current?.pause();
        }
      },
      { threshold: 0.5 }
    );

    if (videoRef.current) {
      observer.observe(videoRef.current);
    }

    return () => {
      observer.disconnect();
    };
  }, []);

  return (
    <div className="size-full bg-white">
      <video
        className="size-full object-cover"
        loop
        muted
        ref={videoRef}
        src={link}
      />
    </div>
  );
}
